"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PermissionsError = require("./PermissionsError");
Object.keys(_PermissionsError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PermissionsError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PermissionsError[key];
    }
  });
});